// import { Map } from 'immutable';
// import { fromJS } from 'immutable';
// export default fromJS(state)

export default {
}
